export const styles = {
	responseList: (background: string) => ({
		background,
		paddingTop: 0,
		margin: 0,
	}),
	responseContainer: (backgroundColor: string) => ({
		backgroundColor,
		padding: '1rem',
	}),
	buttonContainer: (borderColor: string) => ({
		borderBottom: 2,
		borderColor,
	}),
	buttonContent: {
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
	},
	loadingElementContainer: {
		marginTop: '1em',
	},
	solutionText: {
		color: '#000000DE',
		fontStyle: 'italic',
		fontSize: '16px',
		margin: '10px 0 10px 0',
	},
	aiButton: {
		'&&': {
			height: '48px',
		},
	},
	typography: {
		color: 'black',
		opacity: 0.87,
		fontSize: '12px',
	},
	listItem: {
		margin: '10px 0 10px 0',
	},
	LoadingSpinnerBox: {
		display: 'flex',
		height: '1vh',
		justifyContent: 'center',
		alignItems: 'center',
		paddingBottom: '3rem',
		paddingTop: '3rem',
	},
	loadingSpinner: {
		color: 'secondary.main',
	},
}

export const styleProps = {
	button: {
		fullWidth: true,
		color: 'inherit' as const,
	},
	responseText: {
		fontSize: 16,
		color: 'black' as const,
		variant: 'body1' as const,
	},
}
